import { BeforeSend } from "@bugsnag/browser/dist/types/bugsnag-core";
import bugsnag from "@bugsnag/js";
import bugsnagReact from "@bugsnag/plugin-react";

import { APP_VERSION, SSO_CLIENT_ID } from "../app/Config";

// to make sure this is first thing that runs out of all js code
export const bugsnagClient = bugsnag({
    apiKey: process.env.REACT_APP_BUGSNAG_CLIENT_API_KEY || "_",
    endpoints: {
        sessions: "https://bugsnag.8x8.com/session",
        notify: "https://bugsnag.8x8.com/notify",
    },
    appVersion: APP_VERSION,
    releaseStage: process.env.REACT_APP_BUGSNAG_APPLICATION || SSO_CLIENT_ID,
});

export function addBeforeSend(beforeSend: BeforeSend) {
    if (bugsnagClient.config.beforeSend && typeof bugsnagClient.config.beforeSend === "object") {
        bugsnagClient.config.beforeSend.push(beforeSend);
    }
}

// do not throttle errors to 10 events; TODO: maybe we need to reset it once a minute or something like that
addBeforeSend(() => {
    (bugsnagClient as typeof bugsnagClient & { refresh: () => void }).refresh();
});

// this seems to be easiest way to disable error tracking
if (process.env.REACT_APP_BUGSNAG_ENABLED !== "true") {
    addBeforeSend(report => {
        report.ignore();
    });
}

(window as any).bugsnagClient = bugsnagClient;

// run this after bugsnag is already initialized
const React = require("react");
bugsnagClient.use(bugsnagReact, React);

export type FallbackComponentProps = { error: Error; info: React.ErrorInfo };

export const BugsnagErrorBoundary: React.FC<{
    beforeSend?: BeforeSend;
    FallbackComponent?: React.FC<FallbackComponentProps>;
}> = bugsnagClient.getPlugin("react");
